"use client"
import { pageNotFound } from '@/assets/imgs'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'

const Error404 = () => {
  const  t  = useTranslations()
  return (
    <div className='flex h-full min-h-screen items-center justify-center'>
      <div className='flex flex-col items-center justify-center gap-8 pb-10 lg:gap-0'>
        <Image alt='page not found' src={pageNotFound} className='w-1/2 lg:w-2/5' />
        <div>
          <Link
            href='/'
            className='w-fit rounded-full border border-primary bg-white px-10 py-4 text-sm font-semibold text-secondary transition-all duration-200 hover:border-none hover:bg-linear-to-r hover:from-primary hover:from-10% hover:to-secondary hover:text-white sm:text-lg lg:mt-0'
          >
            {t('errors.backHome')}
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Error404
